export default function LegalPage({ title, updated, sections, testid }) {
  return (
    <div className="container-x py-20 lg:py-24" data-testid={testid}>
      <div className="max-w-3xl">
        <div className="eyebrow mb-3">Legal</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight">{title}</h1>
        <p className="mt-3 text-sm text-brand-muted">Last updated: {updated}</p>
        <div className="mt-10 space-y-8">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-display font-bold text-2xl text-brand-ink mb-3">{s.heading}</h2>
              {s.body.map((p, j) => <p key={j} className="text-brand-muted leading-relaxed mb-3">{p}</p>)}
              {s.list && (
                <ul className="list-disc pl-6 text-brand-muted space-y-1">{s.list.map((li, k) => <li key={k}>{li}</li>)}</ul>
              )}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
